// extracted by mini-css-extract-plugin
module.exports = {"text":"OpenButton_text__2SiOl","contained":"OpenButton_contained__35owa","disabled":"OpenButton_disabled__1IdYj","error":"OpenButton_error__1RK_q"};